export default "__VITE_ASSET__C2XDeqb2__"